import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import SavingsTypeTransactionDisplay from './savings_type_transaction_display';
import DropDownOptionCard from '../../shared-components/drop_down_option_card';

class SavingsTransactionHistoryModal extends Component {
        constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state={
            displayInstructions: false,
            openFriendModal: false,
            rerender: null,
        } 
        this.savingsClassDataArr = [];
        this.summaryTranOut = [];
        this.initializationProcess();
    }

initializationProcess(){
    this.getRequestedSavingsData();
    this.reworkSummaryArr();
    this.determineFilterOptions();
    this.combineTranArr = this.newSummaryTranArr.concat(this.savingsClassDataArr);
}
  
getRequestedSavingsData(){
    this.companyMatchRate = (+this.moneyBuildInfo.savingsInfo.companyMatchRate * 100).toFixed(0);
    const savingsInfoArr = JSON.parse(JSON.stringify(this.props.savingsInfo));
    this.savingsClassDataArr = [];
    for (let i=0; i<savingsInfoArr.length; i++){
        const savingsTranArr = JSON.parse(JSON.stringify(this.props.savingsTranArr));
        const tranSelect = 
           savingsTranArr.find(elem => elem.savingsType === savingsInfoArr[i].savingsType);
        const tranArr = tranSelect.savingTranArr;
    //   the following assumes tax trans in a separate array...
       const taxArr = savingsInfoArr[i].taxHistoryArr;
       for (let j=0; j<taxArr.length; j++){
            const tranOut = { tranType: taxArr[j].taxLongText,
                tranDate: taxArr[j].tranDate,
                tranAmt: taxArr[j].tranAmount,
                tranNbr: 9999,
                taxRate: taxArr[j].taxRate,
                incomeAmt: taxArr[j].incomeAmt  }
            tranArr.push(tranOut);
        }
        const tranArrObj = {level:"detail", 
            savingsClass: savingsInfoArr[i].savingsClass,
            savingsType: savingsInfoArr[i].savingsType, 
            interestRate: savingsInfoArr[i].interestRate,
            startDate: savingsInfoArr[i].startDate, 
            monthlyDepositAmt: savingsInfoArr[i].monthlyDepositAmt, 
            tranArr: tranArr};
        this.savingsClassDataArr.push(tranArrObj);
    }
}

determineFilterOptions(){
    this.tranYearOptionsArr = [];
    for (let i=0; i<this.props.summaryArr.length; i++){
        const tranYear = this.props.summaryArr[i].tranYear;
        let selection = tranYear;
        if (tranYear === "all"){
            selection = "All Years";
        }
        const checkTranYearOptions = 
            this.tranYearOptionsArr.find(elem => elem.value === tranYear)
        if (!checkTranYearOptions){
            const tranYearObj = {value: tranYear, selection: selection};
            this.tranYearOptionsArr.push(tranYearObj);
        }
    }
    this.tranYearOptionsArr.sort((a, b) => (a.value > b.value) ? -1 : 1)
}   

filterTransactionHistory(filterYear){
    this.summaryTranOut = this.summaryTranArr.filter(item => item.tranYear === filterYear);
}

reworkSummaryArr(){
    let prevSavingsType = "";
    this.newSummaryTranArr = [];
    let summaryArr = [];
    this.summaryTranArr = JSON.parse(JSON.stringify(this.props.summaryArr));
    for (let i=0; i<this.summaryTranArr.length; i++){
        const savingsType = this.summaryTranArr[i].savingsType;
        if (savingsType !== prevSavingsType){
            if (prevSavingsType !== ""){
                this.newSummaryTranArr.push({level: "summary", savingsType:  prevSavingsType, 
                    summaryArr: summaryArr});
            }
            summaryArr = []
            prevSavingsType = savingsType;
        }
        delete this.summaryTranArr[i].savingsType;
        summaryArr.push(this.summaryTranArr[i]);
    }
    if (prevSavingsType !== ""){
        this.newSummaryTranArr.push({level: "summary", savingsType:  prevSavingsType, 
            summaryArr: summaryArr});
    }
}

render() {
        this.yearOptions = this.tranYearOptionsArr.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
        this.savingsDisplay = this.combineTranArr.map((savingsInfo, index) =>
            <SavingsTypeTransactionDisplay key={index} savingsInfo={savingsInfo}
                gameDate={this.moneyBuildInfo.gameData.currentGameDate}
                savingsClass={this.props.savingsClass}
                currentPriceArr = {this.props.currentPriceArr}
                companyMatchRate = {this.companyMatchRate}
            />
        );
    return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="xl" scrollable="true"
            dialogClassName={this.gutters} animation={false}>
            <Modal.Header className="backgroundTopBottom" closeButton>
                <Modal.Title className="text-center">Bank Account Savings Transactions</Modal.Title>
            </Modal.Header>
        <Modal.Body>
            <div className="overflow-scroll mx-4 mb-5">
                <div style={{ overflowX: 'hidden' }}>
                   {this.savingsDisplay}
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom">
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                     Close
            </Button>
        </Modal.Footer>
    </Modal>
    </>
    }
}

export default SavingsTransactionHistoryModal;